import { LegalShell as Layout } from "@/components/connect/LegalShell";
import { Link } from "react-router-dom";
import { SEOHead } from "@/components/seo/SEOHead";
import { PAGE_SEO, getCanonicalUrl, getBreadcrumbSchema } from "@/config/seo";
import { PrivacyContent } from "@/components/connect/PrivacyContent";

/**
 * Public marketing Privacy page.
 *
 * Single source of truth: renders the same `<PrivacyContent />` used by the
 * authenticated portal page (`ConnectPrivacyPage`) and the in-app dialog.
 * Eliminates drift across the three surfaces.
 */
const PrivacyPolicy = () => {
  return (
    <Layout>
      <SEOHead
        title={PAGE_SEO.privacy.title}
        description={PAGE_SEO.privacy.description}
        keywords={PAGE_SEO.privacy.keywords}
        canonicalUrl={getCanonicalUrl('/legal/privacy')}
        structuredData={getBreadcrumbSchema([
          { name: 'Home', url: 'https://elefa.tel/' },
          { name: 'Privacy Policy', url: 'https://elefa.tel/legal/privacy' },
        ])}
      />
      <section className="py-16">
        <div className="container">
          <div className="mx-auto max-w-4xl">
            <nav className="mb-6 flex items-center gap-2 text-sm text-muted-foreground">
              <Link to="/" className="hover:text-primary transition-colors">Home</Link>
              <span>/</span>
              <span className="text-foreground font-medium">Privacy Policy</span>
            </nav>

            <PrivacyContent />

            <div className="mt-8 flex flex-wrap gap-4 text-sm">
              <Link to="/legal/terms" className="text-primary hover:underline">Terms of Service</Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/legal/cookies" className="text-primary hover:underline">Cookie Policy</Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/regulatory" className="text-primary hover:underline">Regulatory Information</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyPolicy;
